module.exports = __webpack_public_path__ + "static/media/cable.9fa4bb74.svg";